import { provideRouter } from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './security/auth.interceptor';
import { provideAuth0 } from '@auth0/auth0-angular';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { AuthGuard } from './security/auth.guard';
import { AuthRedirectGuard } from './security/auth_redirect.guard';
import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from './date-format';
import { provideServiceWorker } from '@angular/service-worker';
import { maskConfig } from './shared/maskConfiguration';
import { AppErrorHandler } from './security/app-error-handler';
import { ErrorHandler } from '@angular/core';
import { CityService } from './shared/services/city.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: JWT_OPTIONS, useValue: {} },
    JwtHelperService,
    provideEnvironmentNgxMask(maskConfig),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    provideMomentDateAdapter(MY_FORMATS),
    AuthGuard,
    AuthRedirectGuard,
    CityService,
    { provide: ErrorHandler, useClass: AppErrorHandler },
    provideAuth0({
      domain: 'dev-lvh04ko3ted6mpxp.eu.auth0.com',
      clientId: '1WG1PBHI8plF1DCzncPM0JSnhUBY6GR8',
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: 'hubMedical-api',
        issuerBaseURL: 'https://dev-lvh04ko3ted6mpxp.eu.auth0.com/',
        tokenSigningAlg: 'RS256',
      },
    }), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
};
